import React from "react";
import SectionHeading from "./SectionHeading";

export default function SharedHeroSection({
  badge,
  badgeIcon: BadgeIcon,
  title,
  description,
  children,
  titleClassName = "",
  descriptionClassName = "",
  badgeClassName = "",
  containerClassName = "",
  split = false,
  media = null,
  mediaClassName = "",
  contentClassName = "",
}) {
  const isSplit = split && media;

  return (
    <div
      className={`relative overflow-hidden bg-[#03152d] text-white pt-28 pb-16 px-6 sm:px-12 flex flex-col items-center min-h-[70vh] justify-center border-b border-white/5 ${containerClassName}`}
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(52,152,245,0.12),transparent_70%)] pointer-events-none" />
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-[#355dff] opacity-20 blur-[120px] rounded-full pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-[#60a5fa] opacity-20 blur-[100px] rounded-full pointer-events-none" />

      <div
        className={`relative z-10 w-full mx-auto flex ${isSplit ? "max-w-7xl flex-col lg:flex-row items-center gap-10 lg:gap-16" : "max-w-4xl flex-col items-center text-center"}`}
      >
        <div className={`flex-1 ${isSplit ? "flex flex-col items-start text-left pl-0 sm:pl-2 lg:pl-4" : "flex flex-col items-center text-center"} ${contentClassName}`}>
          {badge && (
            <div
              className={`mb-6 px-4 py-1.5 rounded-full bg-white/5 border border-white/10 text-gray-300 text-xs font-semibold tracking-widest uppercase ${badgeClassName}`}
            >
              {BadgeIcon && <BadgeIcon className="w-4 h-4 mr-2 inline" />}
              {badge}
            </div>
          )}

          <SectionHeading
            eyebrow={null}
            title={title}
            description={description}
            theme="dark"
            align={isSplit ? "left" : "center"}
            titleClassName={titleClassName}
            descriptionClassName={descriptionClassName}
            showLine={false}
            titleTag="h1"
            containerClassName="items-start"
          />

          {children}
        </div>

        {isSplit && media && (
          <div className={`w-full lg:w-[45%] flex justify-center ${mediaClassName}`}>
            {media}
          </div>
        )}
      </div>
    </div>
  );
}
